import { Head, Link } from "@inertiajs/react"

import Heading from "@/components/heading"
import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import AppLayout from "@/layouts/app-layout"
import { inviteUsersPath, userPath, usersPath } from "@/routes"
import type { BreadcrumbItem, User } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Users",
    href: usersPath(),
  },
]

interface UsersIndexProps {
  users: User[]
}

export default function UsersIndex({ users }: UsersIndexProps) {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Users" />

      <div className="space-y-6 p-4 lg:p-8">
        <div className="flex items-center justify-between">
          <Heading
            title="Users"
            description="Manage users in your application"
          />
          <Button asChild>
            <Link href={inviteUsersPath()}>Invite user</Link>
          </Button>
        </div>

        <div className="space-y-4">
          {users.map((user) => (
            <div
              key={user.id}
              className="flex flex-col space-y-2 rounded-lg border p-4"
            >
              <div className="flex items-center justify-between">
                <div className="space-y-1">
                  <p className="font-medium">
                    {user.name}
                    <Badge
                      variant={user.admin ? "default" : "secondary"}
                      className="ml-2"
                    >
                      {user.admin ? "Admin" : "User"}
                    </Badge>
                    {user.verified && (
                      <Badge variant="outline" className="ml-1">
                        Verified
                      </Badge>
                    )}
                  </p>
                  <p className="text-muted-foreground text-sm">{user.email}</p>
                  <p className="text-muted-foreground text-sm">
                    Joined {new Date(user.created_at).toLocaleDateString()}
                  </p>
                </div>
                <Button variant="destructive" size="sm" asChild>
                  <Link method="delete" href={userPath(user.id)} as="button">
                    Delete
                  </Link>
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AppLayout>
  )
}
